



























import { Vue, Component } from "vue-property-decorator";
import Axios from "axios";
import { URIs } from "../../../src_server/common/URIs";
import { LineAfterUpdateParam } from "../../../src_server/param/LineAfterUpdateParam";
import { Response } from "../../../src_server/response/Response";
import { UserAuthDTO } from "../../../src_server/entity/dto/UserAuthDTO";

import { Session } from "../../utils/Session";
import { WebUtils } from "../../utils/WebUtils";
import { MessageDialog } from "../../utils/MessageDialog";

@Component({ components: {} })
export default class StudentLineRegistAfterPage extends Vue {
  private error = "";
  private redirectPath = "";
  private errorDetail = "";

  getUserId() {
    return WebUtils.queryToArray(location).filter((item) => item.name === "user_id")[0]
      .value;
  }
  getBuilding() {
    const building = WebUtils.getQueryItem("building", location);
    if (!building) {
      this.error = "認証時に校舎のIDが返却されませんでした。";
      throw Error("認証時に校舎のIDが返却されませんでした。");
    }
    return building;
  }

  errorRedirect() {
    this.$router.push(this.redirectPath);
  }

  redirect() {
    console.log(location);
    this.errorDetail = location.href;
    const paramPath = WebUtils.getQueryItem("redirect", location);
    if (!paramPath) {
      this.error = "認証時にリダイレクト先のパスが返却されませんでした。";
      this.errorDetail = location.href;
      MessageDialog.alert(this.error).then();
      return;
    } // ガード

    this.redirectPath = paramPath;
    const error = WebUtils.getQueryItem("error", location);
    if (error) {
      this.error = error;
      this.errorDetail = location.href;
      MessageDialog.alert(error).then();
    } else {
      const postParam: LineAfterUpdateParam = new LineAfterUpdateParam();
      postParam.userId = this.getUserId();

      postParam.building = this.getBuilding();
      Axios.post<Response<UserAuthDTO>>(URIs.LINE_AFTER.path, postParam)
        .then((res) => {
          Session.set<UserAuthDTO>("USER", res.data.data);
          this.$router.push(this.redirectPath);
        })
        .catch((e) => {
          MessageDialog.alert(e).then();
        });
    }
  }
  created() {
    this.redirect();
  }
}
